/**
 * Communities domain routes
 */
export const routes = {
  communityGroups: {
    root: '/community-groups',
    detail: (groupId: string) => `/community-groups/${groupId}`,
  },
  communities: {
    root: '/communities',
    detail: (communityId: string) => `/communities/${communityId}`,
    classificationTesting: {
      root: (communityId: string) => `/communities/${communityId}/classification-testing`,
      withPrompt: (communityId: string, promptVersion: string) => `/communities/${communityId}/classification-testing?promptVersion=${promptVersion}`,
    },
    contentSearch: {
      root: (communityId: string) => `/communities/${communityId}/content-search`,
    },
    pageHeroExample: {
      root: (communityId: string) => `/communities/${communityId}/page-hero-example`,
    },
    moderation: {
      root: (communityId: string) => `/communities/${communityId}/moderation`,
      traits: (communityId: string) => `/communities/${communityId}/moderation/traits`,
    },
  },
};
